import {
  iconoirArrowRight,
  iconoirBluetooth,
  iconoirBluetoothTag,
  iconoirDownload,
  iconoirMenu,
  iconoirMoreVert,
  iconoirNavArrowDown,
  iconoirNavArrowRight,
  iconoirNumberedListLeft,
  iconoirPlus,
  iconoirXmark,
} from '@ng-icons/iconoir';

export const ngIcons = {
  iconoirNavArrowDown,
  iconoirNavArrowRight,
  iconoirMenu,
  iconoirArrowRight,
  iconoirXmark,
  iconoirPlus,
  iconoirDownload,
  iconoirMoreVert,
  iconoirBluetoothTag,
  iconoirBluetooth,
  iconoirNumberedListLeft,
};
